export const sessionResourcePath = '/session';
